// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__ZU32B","container":"page_container__aoG4z","inner":"page_inner__tDhRL","innerAbout":"page_innerAbout__QpQia"};